const MESSAGE_CLIENT_MANAGEMENT_EXPERIENCE_TYPES = {
  FETCH_LINKS: '[messageClientManagementExperience] fetchLinks',
  FETCH_BREVO_TRANSACTIONAL_MESSAGE_EVENTS: '[messageClientManagementExperience] fetchBrevoTransactionalMessageEvents'
}

export default MESSAGE_CLIENT_MANAGEMENT_EXPERIENCE_TYPES
